import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useLocation } from 'react-router'
import classnames from 'classnames'
import { get, isNull } from 'lodash-es'
import URI from 'urijs'
import Cookies from 'cookies-js'
import bowser from 'bowser'

import {
  VideoPlayerComponent,
  WebinarRoomHeaderComponent,
  WindowTitleComponent,
} from '../../../sharedLegacy/components'
import { WebinarAudienceSidebarFeature } from '../../../sharedLegacy/features'
import { WebinarAudienceMobileSidebarFeature } from '../../../sharedLegacy/features/WebinarAudienceSidebarFeature'
import { initAudienceRoom } from '../../actions'
import { WebinarAudienceWaitingRoomComponent } from '..'
import { useSiteQuery } from '../../../global/blocs/useSite'

import './WebinarAudienceRoomContainerComponent.scss'

const renderContent = (opts) => {
  const { liveData, isBroadcasting } = opts

  if (isNull(liveData)) {
    return null
  }

  const isOnDemand =
    get(liveData, 'enable_ondemand_p') === 1 &&
    get(liveData, 'live_status') === 'previous'

  if (!isBroadcasting && !isOnDemand) {
    return <WebinarAudienceWaitingRoomComponent liveData={liveData} />
  }

  return (
    <VideoPlayerComponent
      object={liveData}
      objectType="live"
      options={{
        autoPlay: 1,
        mutedAutoPlay: 1,
        source: 'site',
        showLogo: 0,
        unmuteButtonPosition: 'center',
        include_actions_p: 0,
      }}
    />
  )
}

const detectMobileDevice = () => {
  const { matches } = window.matchMedia('(max-width: 960px)')

  return matches
}

const WebinarAudienceRoomContainerComponent = (props) => {
  const { liveData, isBroadcasting } = props
  const { data: site } = useSiteQuery()

  const userId = Cookies.get('uuid')

  const location = useLocation()

  const uri = URI(location.search)

  // TODO: this eslint rule disabling should be solved whenever
  // this module is touched again and can be tested

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    props.initAudienceRoom(
      window.LIVE_ID,
      window.LIVE_TOKEN,
      detectMobileDevice(),
      uri.hasQuery('show_thank_you', '1')
    )

    document.body.classList.add('react-audience-room')
  }, [])
  /* eslint-enable react-hooks/exhaustive-deps */

  const liveStatus = get(liveData, 'live_status')

  return (
    <div
      className={classnames('webinar-audience-room-container-component', {
        'has-waiting-room': !isBroadcasting,
      })}
    >
      <WindowTitleComponent
        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        title={`${get(liveData, 'name')} - ${site?.site_name}`}
      />
      <div className="webinar-content">
        <div className="webinar-main-content">
          <WebinarRoomHeaderComponent />
          {renderContent(props)}
        </div>
        {!isNull(liveData) && (
          <>
            {!bowser.mobile ? (
              <WebinarAudienceSidebarFeature
                namespace="webinar-audience-sidebar"
                defaultSidebarTab="info"
                role="audience"
                token={get(liveData, 'token')}
                liveData={liveData}
                uuid={userId}
                peopleTabName="Speakers"
                isQuestionsEnabledDefault={
                  liveStatus !== 'previous' &&
                  get(liveData, 'question_mode') === 'ask'
                }
                canPostChat={liveStatus !== 'previous'}
                canPostQuestions
              />
            ) : (
              <WebinarAudienceMobileSidebarFeature
                namespace="webinar-audience-sidebar"
                defaultSidebarTab="info"
                role="audience"
                token={get(liveData, 'token')}
                liveData={liveData}
                uuid={userId}
                peopleTabName="Speakers"
                isQuestionsEnabledDefault={
                  liveStatus !== 'previous' &&
                  get(liveData, 'question_mode') === 'ask'
                }
                canPostChat={liveStatus !== 'previous'}
                canPostQuestions
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

WebinarAudienceRoomContainerComponent.propTypes = {
  initAudienceRoom: PropTypes.func,
  liveData: PropTypes.object,
  isBroadcasting: PropTypes.bool,
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/no-unused-prop-types
  location: PropTypes.object,
}

const mapStateToProps = (state) => ({
  liveData: state.webinarAudienceRoom.liveData,
  isBroadcasting: state.webinarAudienceRoom.isBroadcasting,
})

export default connect(mapStateToProps, {
  initAudienceRoom,
})(WebinarAudienceRoomContainerComponent)
